import { graphql } from "@/types/gql";

export const QUERY_RESTRICTION_AND_CURB_ZONES = graphql(`
  query curbZonesAndRestrictions(
    $filterInputRestriction: SearchRestrictionInput!
    $filterInputCurbZone: SearchCurbZoneInput!
  ) {
    restrictionsByBounding(filterInput: $filterInputRestriction) {
      id
      curbZoneId
      geoPoint2d
      editLine
      description
      decreeIds
      geometry
      timeSpans {
        startDate
        endDate
        daysOfWeek
        daysOfMonth
        months
        timeOfDayStart
        timeOfDayEnd
      }
      decrees {
        name
        id
      }
      streetName
      streetNumberStart
      streetNumberEnd
      cityId
      type
      width
      calculatedSpaces
      length
    }
    curbZones(filterInput: $filterInputCurbZone) {
      calculatedArea
      calculatedSpaces
      cityId
      curbPolicies {
        id
        curbPolicyId
        name
        rules {
          rate {
            rate
            rateUnit
          }
        }
        color {
          dashed
          fillColor
          lineColor
        }
      }
      editLine
      externalId
      geoPoint2d
      geometry
      id
      curbZoneId
      length
      name
      note
      parkingAngle
      publishedDate
      startDate
      streetName
      streetNumberStart
      streetNumberEnd
      width
    }
  }
`);

export const QUERY_CREATE_RESTRICTION = graphql(`
  mutation CreateRestriction($input: CreateRestrictionInput!) {
    createRestriction(input: $input) {
      id
    }
  }
`);

export const QUERY_UPDATE_RESTRICTION = graphql(`
  mutation updateRestriction($input: UpdateRestrictionInput!) {
    updateRestriction(input: $input) {
      id
    }
  }
`);

export const QUERY_UPDATE_RESTRICTIONS = graphql(`
  mutation BulkUpdateRestrictions($input: BulkUpdateRestrictionsInput!) {
    bulkUpdateRestrictions(input: $input) {
      id
    }
  }
`);

export const QUERY_REMOVE_RESTRICTION = graphql(`
  mutation DeleteRestriction($id: String!) {
    deleteRestriction(id: $id) {
      id
      curbZoneId
    }
  }
`);

export const QUERY_REMOVE_RESTRICTIONS = graphql(`
  mutation BulkDeleteRestrictions($ids: [String!]!) {
    bulkDeleteRestrictions(ids: $ids)
  }
`);
